import  DigitacionContent  from './Digitacion/DigitacionContent';

import React from 'react';
import {useJumboApp} from "@jumbo/hooks";
import {LAYOUT_NAMES} from "../../../layouts/layouts";


const DigitacionPage = () => {
  const {setActiveLayout} = useJumboApp();

  React.useEffect(() => {
      setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
      <div>
        <h2>Digitacion de solicitudes Flujo Express</h2>
            <DigitacionContent/>
      </div>
  );
};

export default DigitacionPage;